import styled from 'styled-components';

export const AnalysisTermCountersWrapperStyled = styled('div')(
  ({ theme: { spacing } }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))',
    gap: spacing([2, 6]),
  })
);
